import { useTranslation } from 'react-i18next';
import { Box, styled } from '@mui/material';
import { IconLogout, IconUser } from 'assets/img';
import { WrapMeWhen } from 'shared/components/common/wrap-me-when';
import { SidebarSectionButton } from './sidebar-button';
import { SidebarSectionList } from './sidebar-section-list';
import { SidebarSectionTitle } from './sidebar-section-title';
import { SidebarSection } from './sidebar-section';

export const SidebarProfileSection = ({
  isSidebarOpen,
  handleToggleUserInfo,
  handleLogout,
  hideProfile = false,
}: {
  isSidebarOpen: boolean;
  handleToggleUserInfo: () => void;
  handleLogout: () => void;
  hideProfile?: boolean;
}) => {
  const { t } = useTranslation('web-common');

  return (
    // it must be styled using style props otherwise mui merges the style with other section stylings and it is ignored
    <SidebarSection style={{ marginTop: 'auto' }}>
      <SidebarSectionTitle isSidebarOpen={isSidebarOpen}>
        {t('sidebar.profile')}
      </SidebarSectionTitle>
      <SidebarSectionList>
        {!hideProfile ? (
          <SidebarSectionButton
            key="profile"
            label={t('sidebar.profile')}
            onClick={handleToggleUserInfo}
            isSidebarOpen={isSidebarOpen}
            icon={<IconUser />}
          />
        ) : null}
        <SidebarSectionButton
          key="logout"
          icon={<LogoutIcon />}
          label={<LogoutLabel isSidebarOpen={isSidebarOpen} />}
          onClick={handleLogout}
          isSidebarOpen={isSidebarOpen}
        />
      </SidebarSectionList>
    </SidebarSection>
  );
};

const LogoutIcon = () => {
  return (
    <LogoutIconWrapper>
      <IconLogout />
    </LogoutIconWrapper>
  );
};

const LogoutLabel = ({ isSidebarOpen }: { isSidebarOpen: boolean }) => {
  const { t } = useTranslation('web-common');
  return (
    <WrapMeWhen
      when={isSidebarOpen}
      wrapper={(children) => <StyledLogoutLabel>{children}</StyledLogoutLabel>}
    >
      <>{t('sidebar.logout')}</>
    </WrapMeWhen>
  );
};

const StyledLogoutLabel = styled('span')(({ theme }) => ({
  color: `${theme.palette.lwDanger[100]}`,
}));

const LogoutIconWrapper = styled(Box)(({ theme }) => ({
  '& svg path': {
    stroke: theme.palette.lwDanger[100],
  },
}));
